import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignUpFormComponent } from './sign-up-form/sign-up-form.component';

export const SignUpRoutes: Routes = [
    { path: "signup", component: SignUpFormComponent }
]